module.exports = __webpack_public_path__ + "img/search2x.png?7edbb580f8cdacb0ee2a5d7349a03476";